
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes06 as ObiDiodes06Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-06.js';
 
 
 

 
 export const ObiDiodes06 = createComponent({
   react: React,
   tagName: 'obi-diodes-06',
   elementClass: ObiDiodes06Element,
   events: {
     
   }
  });
 
 